// extracted by mini-css-extract-plugin
module.exports = {"basicCard":"BasicCard--basicCard--3hy0q","content":"BasicCard--content--drGxP","icon":"BasicCard--icon--1jOcN"};